import { Helmet } from "react-helmet";

const TermsAndConditions = () => {
  return (
    <>
        <Helmet>
            <title>Terms and Conditions | Freelity</title>
            <meta
            name="description"
            content="Read Freelity's Terms and Conditions to understand the rules and policies for using our website and tools."
            />
            <meta name="robots" content="index, follow" />
            <link rel="canonical" href="https://freelity.com/terms-and-conditions" />
        </Helmet>
        <section className="sec-free-tools termsconditions">
            <div className="container">
                
                <h1 className="text-center">📜 Terms & Conditions</h1>
                <p><strong>Last Updated:</strong> May 16, 2025</p>

                <h4>1. Acceptance of Terms</h4>
                <p>
                    By accessing and using Freelity.com, you accept and agree to be bound by these Terms and Conditions. If you do not agree, please do not use our website.
                </p>

                <h4>2. Use of Services</h4>
                <p>
                    Our tools are provided for personal and non-commercial use. You agree not to misuse the services, attempt unauthorized access, or harm the website in any way.
                </p>

                <h4>3. No Warranty</h4>
                <p>
                    All tools and services on Freelity.com are provided "as is" without any warranty or guarantee of any kind. We do not promise that the tools will be error-free or always available.
                </p>

                <h4>4. Limitation of Liability</h4>
                <p>
                    Freelity.com will not be liable for any direct or indirect damages resulting from the use or inability to use our services.
                </p>

                <h4>5. Intellectual Property</h4>
                <p>
                    All content, branding, and tools on this website are owned by Freelity.com. You may not copy, distribute, or modify any part without permission.
                </p>

                <h4>6. Changes to Terms</h4>
                <p>
                    We may update these Terms and Conditions at any time. Continued use of the site means you accept the updated terms.
                </p>

                <h4>7. Contact Us</h4>
                <p>
                    For any questions or concerns regarding these terms, please email us at:
                    📧 <strong>support@freelity.com</strong>
                </p>
            </div>
        </section>
    </>
  );
};

export default TermsAndConditions;
